const running = {
  headingTop: "Staff Picks",
  headingBottom: "Spring Running Kit",
  authors: [
    {
      imageSrc: "https://satchel.rei.com/media/product/shop-the-look-fan-zhou.png",
      name: "Fan Zhou",
      description: "General manager for running and footwear at REI"
    }
  ]
};
const curatedOutfitData = {
  running,
  "default": {
    headingTop: "Staff Picks",
    headingBottom: "Complete the Look",
    authors: [
      {
        imageSrc: "https://satchel.rei.com/media/product/shop-the-look-kelsey-thornton.jpg",
        name: "Kelsey Thornton",
        description: "Sr Digital Merchandiser, Apparel"
      },
      {
        imageSrc: "https://satchel.rei.com/media/product/shop-the-look-lindsey-j.jpg",
        name: "Lindsey Jamieson",
        description: "Digital Merchandiser, Hike & Outside Life"
      }
    ]
  }
};
export {
  curatedOutfitData as default,
  running
};
//# sourceMappingURL=curatedOutfitData.mjs.map
